/* tslint:disable:triple-equals */
import { Component } from '@angular/core';
import 'rxjs/add/operator/map';

import {FilterService} from '../services/filter/filter.service';
import {ReportService} from '../services/report/report.service';
import {ConfigurationService} from '../services/configuration/configuration.service';
import {FormBuilder, FormControl, FormGroup} from '@angular/forms';
import {PanelConfigurationChartMetadataListResult} from '../model/configuration/panelConfigurationChartMetadataResult';
import {PanelConfigurationChartMetadata} from '../model/configuration/panelConfigurationChartMetadata.model';
import {ToastrService} from 'ngx-toastr';
import {IndicatorsChartValue, IndicatorsChartValueResult} from '../model/configuration/indicatorsChartValueResult';
import {async} from '@angular/core/testing';
import {IndicatorFilterModel} from '../model/filter/indicatorFilterModel';
import {BsLocaleService} from 'ngx-bootstrap/datepicker';
import {TypeaheadMatch} from 'ngx-bootstrap/typeahead';

@Component({
  selector: 'interaction',
  templateUrl: './approvalChartResult.component.html',
  styleUrls: ['./approvalChartResult.component.css']
})
export class ApprovalChartResultComponent {

  SearchRecycle: boolean;

  indicatorsChartValue: Array<IndicatorsChartValue>;
  pieChart: PieChart;

  bsRangeValue: Date[];
  doughnutLabels: string[] = [];
  doughnutData: number[] = [];
  hasSearched: boolean;

  approvalChartLists: Array<PanelConfigurationChartMetadata> = [];
  approvalChartSelected: PanelConfigurationChartMetadata;
  approvalChartName: string;

  // Reactive forms
  approvalChartCtrl = new FormControl();

  formApprovalChartConfig = new FormGroup({
    approvalChartList: this.approvalChartCtrl
  });

  errorConfig: boolean;
  errorConfigMessage: string;

  constructor(private filterService: FilterService, private reportService: ReportService,
              private configurationService: ConfigurationService, private fb: FormBuilder,
              private toastr: ToastrService, private localeService: BsLocaleService) {

     this.listConfigurationChart();
     this.hasSearched = false;
     localeService.use('pt-br');

  }

  public listConfigurationChart() {

    this.configurationService.listPanelConfigurationChartMetadata()
        .subscribe((resp: PanelConfigurationChartMetadataListResult) => {
        if (resp.result) {
          this.approvalChartLists = resp.result;
        }
      });
  }

  onClickSearch() {
    this.hasSearched = false;
    if (this.approvalChartSelected == undefined) {
      this.toastr.error('Selecione uma configuração válida!', 'Erro', { positionClass: 'toast-top-center' });
    }

    if (this.bsRangeValue == undefined) {
      this.toastr.error('Selecione um período válido!', 'Erro', { positionClass: 'toast-top-center' });
    }

      const indicatorFilter = this.translateFilter(this.approvalChartSelected.id);

      this.reportService.getApprovalChartValues(indicatorFilter).subscribe(
        async (resp: IndicatorsChartValueResult) => {

          if (resp.result) {

            const _indicatorsChartValue = resp.result;

            const colorHex = new GenerateRandomColor().getColors(_indicatorsChartValue.length);

            this.pieChart = new PieChart(
              _indicatorsChartValue.map(a => a.legend + ' - Qtd:' + a.absValue),
              _indicatorsChartValue.map(a => a.percValue),
              colorHex);

            this.hasSearched = true;
          }

        }
      );
  }

  onClickCleanFilter() {
    this.pieChart = new PieChart([], [], []);
    this.approvalChartName = '';
    this.bsRangeValue = [];
    this.hasSearched = false;
    this.errorConfig = false;
  }

  onSelectConfig(event: TypeaheadMatch) {

    this.approvalChartSelected = event.item;
    this.approvalChartName = event.item.name;
  }

  typeaheadNoResultsConfig(event: boolean): void {
    this.errorConfig = event;
    this.errorConfigMessage = 'Nenhum resultado encontrado';
  }

  removeApprovalChartSelected() {
    this.approvalChartName = '';
    this.errorConfig = false;
  }

  translateFilter(bPDimensionId) {

    const result = {
      businessProcessId: bPDimensionId,
      dateFrom: this.bsRangeValue[0].toISOString(),
      dateTo: this.bsRangeValue[1].toISOString(),
      stateId: undefined,
      userId: undefined,
      groupingId: undefined,
      considerWorkingDays: undefined
    };

    return result;
  }

}

export class PieChart {

  pieChartType: string;
  doughnutChartLabels: string[];
  doughnutChartData: number[];

  chartOptions = {
    tooltips: {
              callbacks: {
                title: function (tooltipItem, data) { return data.labels[tooltipItem[0].index]; },
                        label: function (tooltipItem, data) {
                            const amount = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
                            return amount +  '%';
                          }
                      }
    },
    legend: { position: 'right',
              onClick: (e) => e.stopPropagation(),
              display: true,
              fullWidth: false,
              reverse: false
            }

  };

  doughnutChartColors = [{ backgroundColor: [], borderColor: [], borderWidth: [] }];

  constructor(labels, data, colorHex) {

    this.pieChartType = 'pie';

    const indexes = indexesOf(data, 0);

    this.doughnutChartData = data.filter(function(item, idx) {
      return item != 0;
    });

    this.doughnutChartLabels = labels.filter(function(item, idx) {
      const res = any(indexes, idx);
      return !res;
    });

    this.doughnutChartColors = [
      {
        backgroundColor: colorHex,
        borderColor: colorHex,
        borderWidth: [0]
      }];
  }
}

function indexesOf(arr, target) {
  // Map matching elements to their index, and others to null.
  return arr.map(function (el, i) { return (el === target) ? i : null; })
  // Throw out the nulls.
    .filter(function (x) { return x !== null; });
}

function any(arr, target) {
  return arr.some(elem => elem == target);
}

export class GenerateRandomColor {

  colorHex: string[] = [];

  getHexColor() {
    const letters = '0123456789ABCDEF';
    let color = '#';
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }

  getColors(iteractions: number) {
    const regexp = new RegExp('^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$');

    for (let i = 0; i < iteractions; i++ ) {

      let color = this.getHexColor();

      let isValidColor: boolean;
      isValidColor = regexp.test(color);
      let count: 0;

      while (!isValidColor && count <= 5) {
        color = this.getHexColor();
        isValidColor = regexp.test(color);
        count++;
      }

      this.colorHex.push(color);
    }

    return this.colorHex;
  }

}
